import styled from '@xstyled/styled-components'

export const ScreenContainer = styled.box`
  width: 100%;
  max-width: screen;
  margin: 0 auto;
  padding-left: 3;
  padding-right: 3;
`
